import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  '@keyframes filterChipIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  header: {
    marginBottom: theme.spacing(1.5),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
  },
  titleIcon: {
    fontSize: '1.45rem',
    color: theme.palette.primary.main,
  },
  searchSection: {
    marginBottom: theme.spacing(1.25),
  },
  searchField: {
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-root': {
      borderRadius: 6,
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  filtersCard: {
    marginBottom: theme.spacing(1.5),
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    overflow: 'visible',
    '& .MuiCardContent-root': {
      overflow: 'visible',
    },
  },
  filtersSecondRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
    },
  },
  queryActions: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    flex: '0 0 auto',
    '& button': {
      minHeight: 40,
      textTransform: 'none',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  multiSelectField: {
    position: 'relative',
    width: 340,
    maxWidth: '100%',
    '& .css-1pahdxg-control': {
      boxShadow: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  serviceFilterField: {
    width: 260,
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  searchableSelectField: {
    width: '100%',
    maxWidth: '100%',
    '& .css-1pahdxg-control': {
      boxShadow: 'none',
    },
  },
  ciFilterField: {
    width: 220,
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  cronogramaFilterField: {
    width: 190,
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  multiSelectLabel: {
    display: 'block',
    color: theme.palette.text.secondary,
    marginBottom: 3,
    lineHeight: 1,
  },
  estadoSelectSummary: {
    color: '#111827',
    fontSize: 14,
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
  },
  estadoMenuHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: '#fff',
    borderBottom: '1px solid #e5e7eb',
    padding: theme.spacing(1, 1.25),
  },
  estadoMenuSearchHint: {
    display: 'block',
    color: '#64748b',
    padding: theme.spacing(0.5, 1),
    border: '1px solid #e5e7eb',
    borderRadius: 4,
    backgroundColor: '#f8fafc',
  },
  estadosSeleccionadosPanel: {
    marginTop: theme.spacing(1.25),
    padding: theme.spacing(1, 1.25),
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    backgroundColor: '#fafbfc',
  },
  estadosSeleccionadosHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  estadoSelectedTitle: {
    display: 'block',
    color: '#475569',
    fontWeight: 600,
  },
  limpiarEstadosButton: {
    minHeight: 28,
    padding: theme.spacing(0.25, 1),
    color: '#64748b',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#eef2f7',
      color: '#334155',
    },
  },
  estadoSelectedChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.9),
  },
  estadoSelectedChip: {
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    gap: 6,
    border: '1px solid',
    borderRadius: 16,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.3,
    padding: '5px 8px',
    animation: '$filterChipIn 160ms ease-out',
    '& span': {
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
    },
    '& button': {
      border: 0,
      background: 'transparent',
      color: 'inherit',
      cursor: 'pointer',
      fontWeight: 700,
      fontSize: 15,
      lineHeight: 1,
      marginLeft: 6,
      padding: '1px 4px',
    },
  },
  estadoSelectedDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flex: '0 0 auto',
  },
  resultsToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  exportButton: {
    textTransform: 'none',
  },
  tableContainer: {
    marginTop: theme.spacing(1),
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    overflow: 'hidden',
  },
  tableScroll: {
    maxHeight: 'calc(100vh - 330px)',
    position: 'relative',
  },
  table: {
    minWidth: 1632,
    tableLayout: 'fixed',
  },
  tableHead: {
    '& th': {
      position: 'sticky',
      top: 0,
      zIndex: 4,
      backgroundColor: '#f8fafc',
      color: '#374151',
      fontWeight: 600,
      borderBottom: '1px solid #dfe3ea',
      whiteSpace: 'nowrap',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f8fafc',
    },
    '&:hover $stickyAcciones, &:hover $stickyEstado, &:hover $stickyAlumno': {
      backgroundColor: '#f8fafc',
    },
    '& td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      verticalAlign: 'top',
    },
  },
  badge: {
    padding: theme.spacing(0.35, 1),
    borderRadius: 12,
    fontSize: '0.75rem',
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
  badgeAprobada: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    borderColor: '#4caf50',
  },
  badgePendiente: {
    backgroundColor: '#fff8e1',
    color: '#9a6700',
    borderColor: '#facc15',
  },
  badgeRechazada: {
    backgroundColor: '#fee2e2',
    color: '#b91c1c',
    borderColor: '#fca5a5',
  },
  badgeEnProceso: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    borderColor: '#90caf9',
  },
  badgeModificaciones: {
    backgroundColor: '#e1f5fe',
    color: '#0277bd',
    borderColor: '#81d4fa',
  },
  badgeFinalizada: {
    backgroundColor: '#e0f2f1',
    color: '#00695c',
    borderColor: '#80cbc4',
  },
  badgeArchivada: {
    backgroundColor: '#f4f4f5',
    color: '#52525b',
    borderColor: '#d4d4d8',
  },
  vencimientoBox: {
    marginTop: theme.spacing(0.75),
    '& p': {
      lineHeight: 1.2,
    },
  },
  vencimientoVencido: {
    '& p:last-child': {
      color: '#b91c1c',
      fontWeight: 600,
    },
  },
  stickyAcciones: {
    position: 'sticky',
    left: 0,
    zIndex: 6,
    backgroundColor: '#fff',
    boxShadow: '1px 0 0 #e5e7eb',
  },
  stickyEstado: {
    position: 'sticky',
    left: 64,
    zIndex: 5,
    backgroundColor: '#fff',
    boxShadow: '1px 0 0 #e5e7eb',
  },
  stickyAlumno: {
    position: 'sticky',
    left: 364,
    zIndex: 5,
    backgroundColor: '#fff',
    boxShadow: '1px 0 0 #e5e7eb',
  },
  stickyAccionesHeader: {
    top: 0,
    zIndex: '13 !important',
    backgroundColor: '#f8fafc !important',
    boxShadow: '1px 0 0 #e5e7eb, 0 1px 0 #dfe3ea',
  },
  stickyEstadoHeader: {
    top: 0,
    zIndex: '12 !important',
    backgroundColor: '#f8fafc !important',
    boxShadow: '1px 0 0 #e5e7eb, 0 1px 0 #dfe3ea',
  },
  stickyAlumnoHeader: {
    top: 0,
    zIndex: '12 !important',
    backgroundColor: '#f8fafc !important',
    boxShadow: '1px 0 0 #e5e7eb, 0 1px 0 #dfe3ea',
  },
  estadoColumn: {
    minWidth: 300,
    width: 300,
    maxWidth: 300,
  },
  alumnoColumn: {
    minWidth: 320,
    width: 320,
    maxWidth: 320,
  },
  institucionColumn: {
    minWidth: 250,
    width: 250,
    maxWidth: 250,
  },
  servicioColumn: {
    minWidth: 220,
    width: 220,
    maxWidth: 220,
  },
  fechasColumn: {
    minWidth: 150,
    width: 150,
    maxWidth: 150,
  },
  horasColumn: {
    minWidth: 80,
    width: 80,
    maxWidth: 80,
  },
  tutorColumn: {
    minWidth: 220,
    width: 220,
    maxWidth: 220,
  },
  accionesColumn: {
    minWidth: 64,
    width: 64,
    maxWidth: 64,
  },
  primaryText: {
    fontWeight: 700,
    color: '#111827',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  secondaryText: {
    fontWeight: 500,
    color: '#1f2937',
  },
  metaText: {
    color: '#6b7280',
    lineHeight: 1.35,
  },
  dateText: {
    color: '#374151',
    fontWeight: 500,
  },
  inlineIcon: {
    fontSize: 15,
    color: '#64748b',
    verticalAlign: 'middle',
  },
  hoursBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(8, 2),
  },
}));
